import React from "react";
import PropTypes from "prop-types";
import Marquee from "react-fast-marquee";
import { usePadding } from "@/components/utils/Padding";
import "./styles.scss";

/* #META
 {
  "NAME": "Logos",
  "CLASSNAME": "logos-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const Logos = ({ data }) => {
  const logosModule = data?.name;
  if (!logosModule) return null;

  const { padding_component, logos } = logosModule;

  const paddingStyle = usePadding(padding_component);

  return (
    <section className="logos-component" style={paddingStyle}>
      {logos && logos.length > 0 && (
        <div className="marquee-container">
          <Marquee gradient={false} speed={50} loop={0} autoFill={true}>
            {logos.map((logo, index) => (
              <div key={index} className="logo-item">
                <img src={logo?.url} alt={logo?.alt || logo?.title || ""} />
              </div>
            ))}
          </Marquee>
        </div>
      )}
    </section>
  );
};

Logos.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    name: PropTypes.shape({
      logos: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
          title: PropTypes.string,
        })
      ),
    }),
  }),
};

export default Logos;
